import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Message } from 'antd';
import { connect } from 'react-redux';
import { keys, isObject } from 'lodash';
import { fetchOCR } from '../../api/demonstration';
import OcrCCDemonstration from './OcrCCDemonstration';
import {
  actionCreatorUpdateOverall,
  actionCreatorUpdateAllData,
  actionCreatorUpdateError,
  actionCreatorUpdateSuggestion,
  actionCreatorUpdateConjunction,
  actionCreatorUpdatePhrase,
  actionCreatorUpdateClause
} from '../../store/action-creator-enCorrect';
import {
  PROGRESS_INFO,
  getClauseList,
  getPhrasesList,
  getConjunctionList,
  getProposalListData
} from './utils/enCorrection';
import account from '@/common/account/index';

const ENCompositionCorrection = ({
  materialsPath,
  selectList,
  inputOption,
  initInfo,
  lang,
  // dispatch
  changeAllData,
  changeOverall,
  changeErrorWords,
  changeSuggestionWord,
  changeConjunction,
  changePhrasesList,
  changeClauseList
}) => {
  const [result, setResult] = useState({});
  const [response, setReponse] = useState(null);
  const [request, setRequest] = useState(null);
  const [locationInfo, setLocationInfo] = useState([]);

  const handleCorrectDataEN = (commentsData) => {
    // 所有数据
    changeAllData(commentsData);

    // 整体结果数据
    changeOverall(commentsData.overall_result);

    // 纠错数据
    const errorWords = commentsData.gec_result
      .map((item) => {
        return item.error_info;
      })
      .flat();
    changeErrorWords(errorWords);

    // 建议数据
    const suggestionWord = getProposalListData(commentsData);
    changeSuggestionWord(suggestionWord);

    // 连词数据
    const conjunctionList = getConjunctionList(commentsData);
    changeConjunction(conjunctionList);
    // 词组数据
    const phrasesList = getPhrasesList(commentsData);
    changePhrasesList(phrasesList);

    // 从句数据
    const clauseList = getClauseList(commentsData);
    changeClauseList(clauseList);

    const originTitle = commentsData.original_essay_info.title;
    const originContent =
      commentsData.original_essay_info.original_paragraph_list;
    setResult({ originTitle, originContent } || {});

    // 总评
    setRequest(commentsData.overall_result);
  };

  const changeLocationInfo = () => {
    setLocationInfo([]);
    setRequest(null);
    setReponse(null);
    setResult({});
  };

  const identifyingImg = (params) => {
    if (params.image_base64) {
      fetchOCR({ ...params })
        .then((data) => {
          setReponse(data);
          if (data.code === 20000) {
            handleCorrectDataEN(data.data);
          }
        })
        .catch((err) => {
          Message.error(err.msg || err.message);
          setReponse({});
        });
    } else {
      fetchOCR({ ...params })
        .then((data) => {
          let userId = null;
          const loginEd = account.hasLoggedin();
          if (loginEd) userId = localStorage.getItem('userId') || null;
          if (data.code === 20000) {
            const { detected_text } = data.data;
            fetchOCR({
              method: '/aitext/english-composition/text-correction',
              content: detected_text,
              userId
            }).then((res) => {
              setReponse(res);
              if (res.code === 20000) {
                handleCorrectDataEN(res.data);
              }
            });
          }
        })
        .catch((err) => {
          Message.error(err.msg || err.message);
          setReponse({});
        });
    }
  };

  return (
    <OcrCCDemonstration
      lang={lang}
      result={
        <ul>
          <li>
            <h3 style={{ textAlign: 'center' }}>{result.originTitle}</h3>
          </li>
          {result.originContent &&
            result.originContent.map((resultItem, index) => {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <li key={resultItem + index} className="result_text">
                  <span>{resultItem}</span>
                </li>
              );
            })}
        </ul>
      }
      request={
        request && (
          <>
            {keys(request.category_score).map((e, i) => {
              const item = request.category_score[e];
              return (
                isObject(item) && (
                  <div key={i} style={{ marginBottom: '16px' }}>
                    <p style={{ marginBottom: '8px' }}>
                      【{PROGRESS_INFO[e][0]}】
                    </p>
                    <p style={{ lineHeight: '22px' }}>{item.comment}</p>
                  </div>
                )
              );
            })}
            <p style={{ marginBottom: '8px' }}>【总评】</p>
            <p style={{ lineHeight: '22px' }}>{request.total_comment}</p>
          </>
        )
      }
      response={response}
      handleIdentifyingImg={identifyingImg}
      changeLocationInfo={changeLocationInfo}
      materialsPath={materialsPath}
      selectList={selectList}
      inputOption={inputOption}
      initInfo={initInfo}
      location={locationInfo}
    />
  );
};

ENCompositionCorrection.propTypes = {
  data: PropTypes.shape({
    materialsPath: PropTypes.array,
    selectList: PropTypes.array,
    inputOption: PropTypes.object,
    initInfo: PropTypes.object
  })
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeAllData: (val) => {
      dispatch(actionCreatorUpdateAllData(val));
    },
    changeOverall: (val) => {
      dispatch(actionCreatorUpdateOverall(val));
    },
    changeErrorWords: (val) => {
      dispatch(actionCreatorUpdateError(val));
    },
    changeSuggestionWord: (val) => {
      dispatch(actionCreatorUpdateSuggestion(val));
    },
    changeConjunction: (val) => {
      dispatch(actionCreatorUpdateConjunction(val));
    },
    changePhrasesList: (val) => {
      dispatch(actionCreatorUpdatePhrase(val));
    },
    changeClauseList: (val) => {
      dispatch(actionCreatorUpdateClause(val));
    }
  };
};

export default connect(null, mapDispatchToProps)(ENCompositionCorrection);
